export function getWindowSearch() {
  return window.location.search;
}